export default __webpack_public_path__ + "static/media/airgrop-pic.b0a819bd.png";